import fetch from '@/utils/fetch';

export function unsCreate(params) {
  return fetch({
    url: 'Sbzc/Sbzc/savePostInterpretation',
    method: "post",
    data: params
  });
}

export function unsPredat(params) {
  return fetch({
    url: 'Sbzc/Sbzc/getPostInterpretationById',
    method: "post",
    data: params
  });
}

export function unsList(params) {
  return fetch({
    url: 'Sbzc/Sbzc/getPostInterpretationByWhere',
    method: "post",
    data: params
  });
}

export function unsRemove(params) {
  return fetch({
    url: 'Sbzc/Sbzc/batchDeletePostInterpretation',
    method: "post",
    data: params
  });
}


export function unsStatusSet(params) {
  return fetch({
    url: 'Sbzc/Sbzc/batchUpdatePostInterpretationStatus',
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/unscramble/index.js